module.exports = __webpack_public_path__ + "static/img/bgc1.c58cd313.jpg";